(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Drawer filtri (mobile): open/close
  (function() {
    const container = document.querySelector('[data-collection-filters]');
    if (!container) return;
    const drawer = container.querySelector('[data-filters-drawer]');
    const openBtns = container.querySelectorAll('[data-filters-open]');
    const closeBtns = container.querySelectorAll('[data-filters-close]');

    function open() {
      drawer.setAttribute('data-open', '');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      openBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function close() {
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    }
    openBtns.forEach(function(btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });
  })();

  // Auto-submit del form filtri al cambio di qualsiasi input
  (function() {
    const forms = document.querySelectorAll('[data-filters-form]');
    forms.forEach(function(form) {
      const inputs = form.querySelectorAll('[data-filter-input]');
      let debounceTimer = null;

      function submitForm() {
        // Rimuove parametri vuoti prima del submit per URL puliti
        const submittable = form.cloneNode(true);
        submittable.querySelectorAll('input').forEach(function(input) {
          if (input.type === 'number' && input.value === '') input.disabled = true;
        });
        form.submit();
      }

      inputs.forEach(function(input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.addEventListener('change', submitForm);
        } else if (input.type === 'number') {
          input.addEventListener('input', function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(submitForm, 700);
          });
          input.addEventListener('change', submitForm);
        }
      });

      // Chiudi altri popover quando ne apri uno nuovo
      const pills = form.querySelectorAll('[data-filter-pill]');
      pills.forEach(function(pill) {
        pill.addEventListener('toggle', function() {
          if (pill.open) {
            pills.forEach(function(other) {
              if (other !== pill) other.open = false;
            });
          }
        });
      });

      // Chiudi al click fuori
      document.addEventListener('click', function(e) {
        if (!e.target.closest('[data-filter-pill]')) {
          pills.forEach(function(pill) { pill.open = false; });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
